export const USER_HAS_OPTED_IN_FOR_NEW_UI = "userHasOptedInForNewUI";
